import React from 'react'
import Collapse from '@mui/material/Collapse';
import { useDispatch, useSelector } from 'react-redux';
import Paper from '@mui/material/Paper';
import { setMobileSearchOpen } from '../../../store/user/userSlice';
import Search from './Search';
import { IconButton } from '@mui/material';
import CancelOutlinedIcon from '@mui/icons-material/CancelOutlined';

const MobileSearch = () => {
  const {is_mobile_search_open} = useSelector((state) => state.user);
  const dispatch = useDispatch();
  const handleClick = () => {
    dispatch(setMobileSearchOpen(!is_mobile_search_open));
  }
  return (
    <Collapse 
    in={is_mobile_search_open}
    sx={{
      display : {md:'none',xs:'flex'},
      position:'absolute',
      top:1,
      zIndex :9999,
      width : '100%',
      height : '100%!important',
      bgcolor : 'rgba(0,0,0,0.7)',
      '& .MuiCollapse-wrapperInner':{
        display : 'flex',
        alignItems : 'center',
        flexDirection : 'column'
      }
    }}
    >
      <IconButton sx={{
        color : '#fff'
      }} onClick={handleClick}>
        <CancelOutlinedIcon fontSize='large' />
      </IconButton>
      <Paper sx={{width: '95%', height: 'auto',mt:1}} elevation={0}>
          <Search is_mobile= {true} />
      </Paper>
    </Collapse>
  )
}

export default MobileSearch
